import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import './styles/page-wrapper.css';
import { NavBar } from './nav-bars/navbar';
import { APP_TEXT } from '../const/app-text';
const pageText = APP_TEXT.app;

export const PageWrapper = () => {

  return (
    <>
      <Helmet>
        <title>{pageText.title}</title>
      </Helmet>

      <div className="pageWrapper">
        <NavBar />
        <div
          id="main-content"
        >
          <Outlet />
        </div>
      </div>
    </>
  );
};
